import React from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import intl from 'react-intl-universal'
import CreateStory from '../../reactapp/App/CreateStory'

let toastr
let canCreateStory = true
let hasBlankTemplate = false
const SETTINGS_API_URL = '/settings/api/v1/organization/document'
const HTTP_OK = 200
let controllerLink

const apiCall = async (query) => {
  return await axios.request({
    method: 'get',
    url: `${SETTINGS_API_URL}${query}`,
  })
}

const fetchDefaultTemplate = async (settings) => {
  const { defaultTemplateId } = settings?.data

  if (!defaultTemplateId || defaultTemplateId === 'default') {
    return []
  }

  const defaultTemplate = []

  try {
    const { data, status } = await apiCall(`/${defaultTemplateId}`)

    if (status === HTTP_OK && data) {
      defaultTemplate.push(await data)
    }
    return defaultTemplate
  } catch (error) {
    toastr.error(intl.get('search.template.errorDefaultTemplate'))
    return []
  }
}

const fetchStarredTemplates = async () => {
  let starredTemplates = []
  try {
    const { data, status } = await apiCall(
      `?limit=10&type=template&starred=true&active=true`
    )

    if (status === HTTP_OK && data) {
      starredTemplates = await data.rows
    }

    return starredTemplates
  } catch (error) {
    toastr.error(intl.get('search.template.errorStarredTemplates'))
    return []
  }
}

async function fetchTemplates({ fetchSettings }) {
  const settings = await fetchSettings()
  const defaultTemplate = await fetchDefaultTemplate(settings)
  const starredTemplates = await fetchStarredTemplates()

  return {
    defaultTemplate,
    starredTemplates,
  }
}

async function mountReactCreateStoryComponent(controller) {
  const { defaultTemplate, starredTemplates } = await fetchTemplates(controller)

  ReactDOM.render(
    <CreateStory
      defaultTemplate={defaultTemplate}
      starredTemplates={starredTemplates}
      browseAllTemplates={controller.browseAllTemplates}
      canCreateStory={canCreateStory}
      hasBlankTemplate={hasBlankTemplate}
      composerSettings={controller.companySettings}
    />,
    controllerLink.createStoryButtonWrapper
  )
}

function link(scope, element, attrs, controller) {
  if (!controller.shouldRerender) {
    controllerLink = controller
    canCreateStory = scope.canCreateStory
    hasBlankTemplate = scope.companySettings.defaultTemplateIdVisible

    // It needs to be done like this because the button is using React
    toastr = controller.toastrService
    mountReactCreateStoryComponent(controller)

    return null
  }

  /**
   * Needs to be unmounted in case the user close the modal
   * and we need to re-render the button and updating the
   * Defautl and Starred list
   */
  ReactDOM.unmountComponentAtNode(controller.createStoryButtonWrapper)
  mountReactCreateStoryComponent(controller)
}

export default link
